<template>
  <div>
    <nav class="uk-navbar-container custom-nav" uk-navbar>
      <div class="uk-navbar-left">
        <ul class="uk-navbar-nav">
          <li class="nav-logo-container">
            <a href="/">
              <img :width="logoWidth" :src="logo" />
            </a>
          </li>
        </ul>
      </div>

      <Slide right :closeOnNavigation="true" class="nav-hamburger">
        <a :href="findingsPath2021"
        ><span class="nav-hamburger__text">NEW 2021 Report</span></a
        >
        <a :href="findingsPath2020"
          ><span class="nav-hamburger__text">Finding: 2020 Report</span></a
        >
        <router-link
          v-for="hlink in hamburgerLinks"
          :to="{ path: hlink.route }"
          :key="hlink.route"
        >
          <span class="nav-hamburger__text">{{
            $t(`message.${hlink.name}`)
          }}</span>
        </router-link>
        <SocialWidget :color="'white'" :is-large="true" />
        <Counter
          :suffix-highlight="true"
          :isLoading="isLoadingCount"
          :totalCount="count"
        />
      </Slide>

      <Counter
        class="nav-counter"
        :isLoading="isLoadingCount"
        :totalCount="count"
      />

      <div class="uk-navbar-right nav-regular-nav">
        <ul class="uk-navbar-nav">
          <li class="nav-link-long">
            <a :href="findingsPath2021" target="_blank">{{ $t(`message.${"NEW 2021 Report"}`) }}</a>
          </li>
          <li class="nav-link-long">
            <a :href="findingsPath2020" target="_blank">{{ $t(`message.${"Finding 2020 Report"}`) }}</a>
          </li>
          <li :class="link.style" v-for="link in links" v-bind:key="link.route">
            <router-link :to="{ path: link.route }" :key="link.route">
              {{ $t(`message.${link.name}`) }}
            </router-link>

            <!-- <div v-if="link.route == 'resources'" class="uk-navbar-dropdown"> -->
            <!-- <ul class="uk-nav uk-navbar-dropdown-nav"> -->
            <!-- <li v-for="subLink in subLinks" :key="subLink.route">
                  <router-link
                    :to="{ path: subLink.route }"
                    :key="subLink.route"
                  >
                    {{ $t(`message.${subLink.name}`) }}
                  </router-link>
                </li> -->
            <!-- </ul> -->
            <!-- </div> -->

          </li>
          <!-- <ul class="uk-navbar-nav">
            <li class="nav-link">
              <router-link :to="{ path: 'about' }">
                {{ $t(`message.About`) }}
              </router-link>
            </li>
          </ul> -->
        </ul>
      </div>
      <LanguageToggle />
      <SocialWidget class="nav-social-widget" />
    </nav>
  </div>
</template>

<script>
import { Slide } from "vue-burger-menu";
import LanguageToggle from "./LanguageToggle";
import SocialWidget from "./SocialWidget";
import Counter from "./Counter";
import gql from "graphql-tag";
const LINKS = [
  // {
  //   name: "Incident Timeline",
  //   route: "timeline",
  // },
  // {
  //   name: "Incident map",
  //   route: "map",
  // },
  {
    name: "Report an incident",
    route: "report",
    style: "nav-link-long",
  },
  {
    name: "Resources",
    route: "resources",
    style: "nav-link",
  },
  {
    name: "Podcast",
    route: "podcast",
    style: "nav-link",
  },
  {
    name: "About",
    route: "about",
    style: "nav-link",
  },
];

const URL = "https://ccnc-be.herokuapp.com/count";
const SUB_LINKS = [
  // { name: "Myths", route: "myths" }
];

const SUBMISSION_COUNT_BEFORE_DELETE = 700;

export default {
  name: "Nav",
  components: { Slide, LanguageToggle, SocialWidget, Counter },
  data() {
    return {
      links: LINKS,
      subLinks: SUB_LINKS,
      hamburgerLinks: [...LINKS, ...SUB_LINKS],
      categories: [],
      count: null,
      isLoadingCount: true,
      findingsPath2020:
        "https://drive.google.com/file/d/193CdlC8uq623VRlAzoO3ShfDTEutXQi2/view",
      findingsPath2021:
       "https://drive.google.com/file/d/1U2ki5j-h9y229pAwx-KkqjK0HmAIo9h9/view?usp=sharing",
    };
  },
  async created() {
    const response = await fetch(URL);
    const data = await response.json();
    this.count = data[0].count + 140 + SUBMISSION_COUNT_BEFORE_DELETE;
    this.isLoadingCount = false;
  },
  computed: {
    isHomePage() {
      return this.$route.path === "/";
    },
    logoWidth() {
      return this.isHomePage ? 80 : 100;
    },
    logo() {
      if (this.isHomePage) {
        return require("@/assets/images/logo_plain.png");
      }
      return require("@/assets/images/logo_mask.png");
    },
  },
  apollo: {
    categories: gql`
      query Categories {
        categories {
          id
          name
        }
      }
    `,
  },
};
</script>
<style>
.custom-nav {
  display: flex;
  align-items: center;
  padding-right: 50px;
  -webkit-box-shadow: 0px 1px 10px #999;
  -moz-box-shadow: 0px 1px 10px #999;
  box-shadow: 0px 1px 7px #999;
}

.nav-language-toggle {
  display: flex;
  align-self: center;
}

.nav-link > a, .nav-link-long > a {
  text-align: center;
  color: #000000 !important;
  font-weight: 700;
}

.nav-link {
  width: 120px;
}

.nav-link-long {
  width: 200px;
}

.nav-logo-container {
  width: auto;
}

.nav-dropdown {
  margin-top: -10px;
}

.nav-regular-nav {
  display: block;
}
.nav-hamburger {
  display: none;
}
.nav-hamburger__text {
  text-transform: uppercase;
}

.bm-overlay {
  background: rgba(255, 255, 255, 0.3);
}

.nav-social-widget {
  margin-left: 20px;
}

@media only screen and (max-width: 870px) {
  .nav-regular-nav {
    display: none;
  }
  .nav-hamburger {
    display: block;
  }
  .nav-social-widget {
    display: none;
  }
  .nav-counter {
    display: none;
  }
}
</style>
